<div
  class="gallery-overlay"
  role="dialog"
  aria-modal="true"
  aria-label="Full screen image viewer"
  (click)="onBackdropClick($event)"
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
>
  <!-- Download Button -->
  <!-- <button class="gallery-download" (click)="downloadImage($event)" aria-label="Download active image" type="button">
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  </button> -->

  <!-- Close Button -->
  <button class="gallery-close" (click)="onClose()" aria-label="Close image viewer" type="button">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>

  <!-- Counter -->
  <div class="gallery-counter" aria-live="polite">
    {{ currentIndex() + 1 }} / {{ images.length }}
  </div>

  <!-- Previous Button -->
  <button
    class="gallery-nav prev"
    (click)="prev()"
    [disabled]="currentIndex() === 0"
    aria-label="Previous image"
    type="button"
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  </button>

  <div class="gallery-stage">
    <ng-container *ngFor="let img of images; let i = index">
      <img
        *ngIf="img.type !== 'video'"
        [src]="img.url"
        [alt]="'Product image ' + (i + 1)"
        [class.active]="i === currentIndex()"
        loading="lazy"
      />
      <video
        *ngIf="img.type === 'video'"
        controls
        autoplay
        playsinline
        [src]="img.url"
        [class.active]="i === currentIndex()"
        style="
          max-height: 90vh;
          max-width: 90vw;
          object-fit: contain;
          width: 100%;
          height: auto;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s;
        "
        [style.opacity]="i === currentIndex() ? 1 : 0"
        [style.pointer-events]="i === currentIndex() ? 'auto' : 'none'"
      ></video>
    </ng-container>
  </div>

  <!-- Next Button -->
  <button
    class="gallery-nav next"
    (click)="next()"
    [disabled]="currentIndex() === images.length - 1"
    aria-label="Next image"
    type="button"
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  </button>

  <!-- Thumbnail Strip -->
  <div class="gallery-thumbs" *ngIf="images.length > 1">
    <button
      *ngFor="let img of images; let i = index"
      class="thumb-btn"
      [class.active]="i === currentIndex()"
      (click)="goTo(i)"
      [attr.aria-label]="'Go to image ' + (i + 1)"
      [attr.aria-current]="i === currentIndex() ? 'true' : null"
      type="button"
    >
      <img
        *ngIf="img.type !== 'video'"
        [src]="img.thumbUrl || img.url"
        [alt]="'Thumbnail ' + (i + 1)"
        loading="lazy"
      />
      <video
        *ngIf="img.type === 'video'"
        [src]="img.thumbUrl || img.url"
        muted
        style="height: 100%; width: 100%; object-fit: cover"
      ></video>
    </button>
  </div>
</div>
